import {Z_BUY_NOW_PAY_LATER_PAYMENT_KEY} from '../components/PaymentSlots/constants';
import {useScayleConfig} from './useScayleConfig';
import {useScayleState} from './useScayleState';

export const useScaylePaymentMethodState = () => {
  const {data: scayleState} = useScayleState();
  const {data: scayleConfig} = useScayleConfig();

  const bnplOption = scayleState?.orderOptions?.payment?.generic?.find(
    option => option.paymentOptionKey === Z_BUY_NOW_PAY_LATER_PAYMENT_KEY,
  );

  const hasBnplConsentCheckbox =
    scayleConfig?.dynamicFields?.paymentOptions?.zalandoConsent?.conditions?.enabled?.paymentOptionKey?.includes(
      Z_BUY_NOW_PAY_LATER_PAYMENT_KEY,
    ) ?? false;

  const selectedPaymentOption = scayleState?.orderState?.payment?.selected?.[0];
  const selectedShippingOption =
    scayleState?.orderState?.shipping?.selected?.[0];

  return {
    bnplOption,
    hasBnplConsentCheckbox,
    selectedPaymentOption,
    selectedShippingOption,
  };
};
